export const plantasKeys = {
  plantas: ['plantas'] as const,
  listaPorBloco: (idExternoBloco: number) => [...plantasKeys.plantas, 'bloco', idExternoBloco] as const,
}
